import {ComponentEnum} from '../componentsRegistry/Registry'
import {IWindowTabMap} from './IWindowTabMap'

export enum WindowEnum {
  topLeftWindow = 'topLeftWindow',
  bottomLeftWindow = 'bottomLeftWindow',
  topRightWindow = 'topRightWindow',
  bottomRightWindow = 'bottomRightWindow',
}

export interface IWindow {
  activeComponentId: ComponentEnum
  isCollapsed: boolean //только у нижних окон
  tab: IWindowTabMap
}
